<template>
  <table class="deal-table">
    <thead>
      <tr>
        <th class="text-align-left">
          {{ __('Estágio') }}
        </th>
        <th>{{ __('Número de negócios que alcançaram este estágio') }}</th>
        <th>{{ __('Valor dos negócios que alcançaram este estágio') }}</th>
        <th>{{ __('Valor médio dos negócios') }}</th>
        <th>{{ __('Dias em média para alcançar este Estágio') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="stage in list">
        <td class="text-align-left">
          {{ name(stage.id) }}
        </td>
        <td>{{ stage.count || 0 | number(0) }}</td>
        <td>{{ stage.total || 0 | number(0) }}</td>
        <td>{{ stage.total / stage.count || 0 | number }}</td>
        <td>{{ stage.average_days_to_reach || 0 | number(0) }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ['list', 'stages'],

  methods: {
    name (id) {
      return this.stages[id].name;
    },
  },
};
</script>
